import introJs from 'intro.js'
import 'intro.js/minified/introjs.min.css'

class GuideService {
  constructor() {
    this.intro = null
    this.guideSteps = {}
    this.currentGuideKey = null
  }

  /**
   * 注册引导步骤
   * @param {string} key - 引导唯一标识
   * @param {Array} steps - 引导步骤数组
   * @param {Object} options - 引导选项
   */
  registerGuide(key, steps, options = {}) {
    this.guideSteps[key] = {
      steps,
      options: {
        showProgress: true,
        showBullets: true,
        disableInteraction: false,
        exitOnOverlayClick: false,
        nextLabel: '下一步',
        prevLabel: '上一步',
        skipLabel: '跳过',
        doneLabel: '完成',
        ...options
      }
    }
  }

  /**
   * 开始引导
   * @param {string} key - 引导唯一标识
   * @param {Function} onComplete - 引导完成回调
   */
  startGuide(key, onComplete) {
    if (!this.guideSteps[key]) {
      console.warn(`Guide with key "${key}" not found`)
      return
    }

    // 如果当前有引导正在进行，先退出
    if (this.intro) {
      this.exitGuide()
    }

    const guideConfig = this.guideSteps[key]
    this.currentGuideKey = key

    this.intro = introJs()
    this.intro.setOptions({
      steps: guideConfig.steps,
      ...guideConfig.options
    })

    // 设置完成回调
    if (onComplete) {
      this.intro.oncomplete(onComplete)
      this.intro.onexit(onComplete)
    }

    this.intro.start()

    return this.intro
  }

  /**
   * 退出当前引导
   */
  exitGuide() {
    if (this.intro) {
      this.intro.exit()
      this.intro = null
      this.currentGuideKey = null
    }
  }

  /**
   * 检查引导是否已经显示过
   * @param {string} key - 引导唯一标识
   * @returns {boolean}
   */
  hasShownGuide(key) {
    return localStorage.getItem(`guide_${key}_shown`) === 'true'
  }

  /**
   * 标记引导已显示
   * @param {string} key - 引导唯一标识
   */
  markGuideAsShown(key) {
    localStorage.setItem(`guide_${key}_shown`, 'true')
  }

  /**
   * 重置引导状态
   * @param {string} key - 引导唯一标识
   */
  resetGuide(key) {
    localStorage.removeItem(`guide_${key}_shown`)
  }

  /**
   * 重置所有引导状态
   */
  resetAllGuides() {
    Object.keys(localStorage).forEach(key => {
      if (key.startsWith('guide_') && key.endsWith('_shown')) {
        localStorage.removeItem(key)
      }
    })
  }
}

// 创建单例实例
const guideService = new GuideService()

export default guideService
